import React from 'react';
import { Select } from 'antd';
import { useQuery } from 'react-query';

import {
  getParTaxListByTaxFlow,
  ParTaxResponse,
} from 'services/parametersService';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';

const { Option } = Select;

export type TaxSelectProps = SelectProps<any> & {
  taxflow: string;
  onSelected?: (tax: ParTaxResponse) => void;
};

const TaxSelect = ({
  taxflow,
  value,
  onChange = noop,
  onSelected,
  allowClear,
  ...rest
}: TaxSelectProps) => {
  const { data } = useQuery(['getParTaxListByTaxFlow', { taxflow }], () =>
    getParTaxListByTaxFlow({ taxflow }).then((res) => res.list || [])
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected) {
      onSelected(data?.find((item) => item.taxcode === value)!);
    }
  };

  return (
    <Select allowClear={allowClear} onChange={handleChange} value={value} {...rest} >
      {data?.map((item, index) => (
        <Option key={index} value={item.taxcode}>
          {item.taxlabel}
        </Option>
      ))}
    </Select>
  );
};

export default TaxSelect;
